import { createInterceptors } from "@API/middleware";
import { AxiosInstance, HttpStatusCode } from "axios";

export const createGetPendingUserUpdateRequestsInterceptors = (
  request: AxiosInstance
): void => {
  createInterceptors(request, {
    responseSuccessMessage:
      "A list of pending user update requests is returned.",
    responseErrorMessage:
      "An error occurred while fetching pending user update requests.",
    errorCallbackMessages: {
      [HttpStatusCode.Unauthorized]:
        "You need to have a valid keycloak token to access this endpoint.",
      [HttpStatusCode.Forbidden]:
        "You are not allowed to manage user update requests in this organization.",
      [HttpStatusCode.ImATeapot]:
        "This device is unknown to the backend; you have to do a device specific 2FA.",
    },
  });
};

export const createPutUserUpdateRequestActionInterceptors = (
  request: AxiosInstance,
  action: "approve" | "decline"
): void => {
  createInterceptors(request, {
    responseSuccessMessage: `User update request ${action}d successfully.`,
    responseErrorMessage: `An error occurred while ${action}ing the user update request.`,
    errorCallbackMessages: {
      [HttpStatusCode.BadRequest]:
        "This user update request has already been approved or declined.",
      [HttpStatusCode.Unauthorized]:
        "You need to have a valid keycloak token to access this endpoint.",
      [HttpStatusCode.Forbidden]:
        "You are not allowed to manage user update requests in this organization.",
      [HttpStatusCode.NotFound]:
        "User update request not found in this organization.",
      [HttpStatusCode.ImATeapot]:
        "This device is unknown to the backend; you have to do a device specific 2FA.",
    },
  });
};
